// NOTE: NSAI-6589 — the URL query params global search deep links carry into
// the pages they open. Each page reads its own param, acts on it once and
// removes it, so a reload or a Back does not replay the jump.
export const GLOBAL_SEARCH_DEEP_LINK_PARAMS = {
  // NOTE: /settings — a GLOBAL_SEARCH_SETTING_IDS value; the control carrying
  // the same `data-global-search-setting` is scrolled to and highlighted.
  SETTING: "setting",
  // NOTE: /settings — a row (member, role, invitation, API key, memory fact)
  // to bring into view.
  HIGHLIGHT: "highlight",
  // NOTE: /settings?tab=history — prefills the activity-history search box.
  HISTORY_SEARCH: "search",
  // NOTE: /models — opens that model's details modal.
  MODEL: "model",
  // NOTE: /knowledge — brings that file's row into view.
  KNOWLEDGE_FILE: "file",
  // NOTE: /chat-folders — expands that folder.
  CHAT_FOLDER: "folder",
  // NOTE: /prompt-library — expands the folder and scrolls to the prompt.
  PROMPT_FOLDER: "folder",
  PROMPT: "prompt",
  // NOTE: /analytics?tab=probes — opens that probe.
  PROBE: "probeUuid",
  // NOTE: /agents — selects that tab (the page's ?runs= opens a run drawer).
  AGENTS_TAB: "tab",
  AGENTS_RUNS: "runs",
  // NOTE: /chat — pre-selects an assistant, starts in a folder, or highlights
  // a message; all three are params the chat page already reads.
  CHAT_ASSISTANT: "assistant",
  CHAT_FOLDER_ID: "folder",
  CHAT_MESSAGE: "highlight",
  // NOTE: /integrations, /knowledge, /analytics — the page's own tab param.
  TAB: "tab",
} as const;

// NOTE: The attribute a settings control's wrapper carries so a
// `?setting=<id>` deep link can find it.
export const GLOBAL_SEARCH_SETTING_ATTRIBUTE = "data-global-search-setting";

// NOTE: The attribute a row carries (a member, role, invitation, API key,
// memory fact) so a `?highlight=<uuid>` deep link can find it.
export const GLOBAL_SEARCH_HIGHLIGHT_ATTRIBUTE =
  "data-global-search-highlight-id";

// NOTE: Set on a deep-linked element while it is ringed; index.css styles it.
export const GLOBAL_SEARCH_HIGHLIGHTED_ATTRIBUTE =
  "data-global-search-highlighted";

// NOTE: How long a deep-linked element stays highlighted, and how long a page
// may take to render it (tabs load their data first) before the jump is
// abandoned.
export const GLOBAL_SEARCH_HIGHLIGHT_DURATION_MS = 2500;
export const GLOBAL_SEARCH_HIGHLIGHT_WAIT_MS = 8000;
// NOTE: NSAI-6751 — a row (`?highlight=`) may first need its page found and
// loaded (a memory fact past page 1 is two requests away), so it waits longer.
export const GLOBAL_SEARCH_ROW_HIGHLIGHT_WAIT_MS = 15000;

// NOTE: The Docusaurus local-search results page under the /docs mount.
export const GLOBAL_SEARCH_DOCS_SEARCH_PATH = "/docs/search";
